const leftArrow =
  "<svg xmlns='http://www.w3.org/2000/svg' width='17' height='16' fill='none'><path fill='#28242E' fill-rule='evenodd' d='M10.972 12.463a.666.666 0 0 1-.943 0l-4-4a.667.667 0 0 1 0-.943l4-4a.667.667 0 0 1 .943.943L7.443 7.992l3.529 3.528a.667.667 0 0 1 0 .943Z' clip-rule='evenodd'/></svg>";

const rightArrow =
  "<svg xmlns='http://www.w3.org/2000/svg' width='17' height='16' fill='none'><path fill='#28242E' fill-rule='evenodd' d='M6.028 3.528a.667.667 0 0 1 .943 0l4 4a.667.667 0 0 1 0 .943l-4 4a.667.667 0 0 1-.943-.943L9.557 8 6.028 4.47a.667.667 0 0 1 0-.942Z' clip-rule='evenodd'/></svg>";

module.exports = {
  leftArrow,
  rightArrow,
};
